// extracted by mini-css-extract-plugin
module.exports = {"specialOffers":"special-offers_specialOffers__AV2rl","inner":"special-offers_inner__cBfam","parentWindowDesktop":"special-offers_parentWindowDesktop__oJl88"};